import { updateUserMetadata, fetchUser } from './visitors.utils';
import Vue from 'vue';

export default {
    namespaced: true,
    state: {
        userMap: {
            visitor: {},
            account: {},
            parentAccount: {},
        },
        error: {},
        fetching: {},
    },
    mutations: {
        setUserAtKey (state, { kind, userId, user }) {
            Vue.set(state.userMap[kind], [userId], user);
        },
        setUserMetadata (state, { kind, userId, group, field, data }) {
            const user = state.userMap[kind][userId];
            if (!user || !user.metadata) return;
            if (!user.metadata[group]) {
                Vue.set(user.metadata, group, { [field]: data });
            } else {
                Vue.set(user.metadata[group], field, data);
            }
        },
        setError (state, { error }) {
            state.error = error;
        },
        setFetching (state, { fetching }) {
            state.fetching = fetching;
        },
    },
    actions: {
        /* eslint-disable no-shadow-restricted-names */
        toggleDesignerForVisitorIds (undefined, { visitorIds, enabled }) {
            const payload = visitorIds.map((visitorId) => {
                return {
                    visitorId,
                    values: {
                        designerenabled: enabled,
                    },
                };
            });

            return updateUserMetadata('visitor', 'pendo', payload);
        },
        async fetchUser ({ getters, commit }, { kind, userId, reFetch = false, abortSignal }) {
            const user = getters.userByKindAndId(kind, userId);
            if (!reFetch && user) {
                return Promise.resolve(user);
            }
            commit('setFetching', { fetching: true });
            try {
                const { data } = await fetchUser(kind, userId, abortSignal);
                commit('setFetching', { fetching: false });
                commit('setUserAtKey', { kind, userId, user: data });

                return data;
            } catch (error) {
                commit('setFetching', { fetching: false });
                commit('setError', { error });
                throw error;
            }
        },
        async updateUserMetadata ({ commit }, { kind, userId, group, field, data }) {
            commit('setFetching', { fetching: true });
            const payload = [
                {
                    [`${kind}Id`]: userId,
                    values: {
                        [field]: data,
                    },
                },
            ];
            try {
                const { data: resp } = await updateUserMetadata(kind, group, payload);
                commit('setFetching', { fetching: false });
                if (resp.errors && resp.errors.length) {
                    const { error } = resp.errors[0];
                    throw new Error(error);
                } else {
                    commit('setUserMetadata', { kind, userId, group, field, data });
                }
            } catch (error) {
                commit('setFetching', { fetching: false });
                commit('setError', { error });
                throw error;
            }
        },
    },
    getters: {
        userByKindAndId: (state) => (kind, userId) => state.userMap[kind][userId],
    },
};
